import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FullWidthSection from '../FullWidthSection'
import Link from '../Link'
import { ThemeConsumer } from '../../state'

const Container = styled.ul`
  list-style: none;
  margin: 0;
  text-align: center;

  li {
    display: inline-block;
    margin: 0;
    padding: 1.4rem 3rem;
    text-transform: uppercase;
    font-size: 1.4rem;
    border-right: 0.1rem solid ${({ theme }) => theme.colors.pageRule};

    a {
      color: ${({ theme }) => theme.colors.text};

      &:hover {
        color: ${({ theme }) => theme.colors.interactiveHighlight};
      }

      &.active {
        color: ${({ theme }) => theme.colors.interactive};
      }
    }
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.dimensions.screenSizes.medium - 1}px) {
    li {
      border: none;
      padding: 1.4rem 2.6rem;
    }
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.dimensions.screenSizes.small - 1}px) {
    li {
      display: block;
    }
  }
`

const ContentNavigation = ({ items }) => (
  <ThemeConsumer>
    {({ theme }) => (
      <FullWidthSection background={`${theme.colors.textInverted}`}>
        <Container>
          {items.map((item) => (
            <li key={JSON.stringify(item)}>
              <Link
                tracking={{ label: `content_navigation_${item.href}` }}
                href={item.href}
                activeClassName="active"
                partiallyActive={item.partiallyActive}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </Container>
      </FullWidthSection>
    )}
  </ThemeConsumer>
)

ContentNavigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      partiallyActive: PropTypes.bool
    })
  ).isRequired
}

export default ContentNavigation
